import React from 'react';
import cn from 'classnames';

import Circle from './Circle';
import styles from './Classification.module.css';

import AnnotationName from '../shared/AnnotationName';
import Instruction from '../shared/Instruction';

const Classification = ({ animate, image }) => (
  <div className="h-full rounded-lg overflow-hidden">
    <AnnotationName icon="classification" name="Classification" />
    <Instruction instruction="What is the sentiment of this review?" marginOver />
    <div className="pb-6 px-6 -mt-14 flex flex-col items-center">
      <figure className="bg-white shadow-xl rounded-lg w-24 h-24 p-4 mb-6">
        <img className="w-full h-full" src={image.src} alt={image.alt} />
      </figure>
      <div className="mb-6">
        <p className={cn(styles.shimmer, { [`${styles.animate}`]: animate }, 'italic text-sm leading-6')}>
          &quot;The sound is great, and the noise canceling works surprsingly well. They&apos;re
          also quite comfortable!&quot;
        </p>
      </div>
      <ul className="w-full flex justify-around">
        <Circle text="Negative" />
        <Circle text="Neutral" />
        <Circle text="Positive" animate={animate} />
      </ul>
    </div>
  </div>
);

Classification.defaultProps = {
  image: {
    src: '/static/img/examples/text-classification.png',
    alt: 'Beats headphones'
  }
};

export default Classification;
